import {
    GET_ZIP,
    GET_ZIP_SUCCESS,
    GET_ZIP_FAILURE,
    DELETE_ZIP,
    DELETE_ZIP_SUCCESS,
    DELETE_ZIP_FAILURE,
    UPDATE_ZIP_STATUS,
    UPDATE_ZIP_STATUS_SUCCESS,
    UPDATE_ZIP_STATUS_FAILURE,
    GET_STATES,
    GET_STATES_SUCCESS,
    GET_STATES_FAILURE,
    EDIT_ZIP,
    EDIT_ZIP_SUCCESS,
    EDIT_ZIP_FAILURE,
    ADD_ZIP,
    ADD_ZIP_SUCCESS,
    ADD_ZIP_FAILURE,
    IMPORT_ZIP_DATA,
    IMPORT_ZIP_DATA_SUCCESS,
    IMPORT_ZIP_DATA_FAILURE
} from "../Constants";

export const GetZip = (payload) => ({
    type: GET_ZIP,
    payload
});

export const GetZipSuccess = (payload) => ({
    type: GET_ZIP_SUCCESS,
    payload
});

export const GetZipFailure = (payload) => ({
    type: GET_ZIP_FAILURE,
    payload
});

export const DeleteZip = (payload) => ({
    type: DELETE_ZIP,
    payload
});

export const DeleteZipSuccess = (payload) => ({
    type: DELETE_ZIP_SUCCESS,
    payload
});

export const DeleteZipFailure = (payload) => ({
    type: DELETE_ZIP_FAILURE,
    payload
});

export const UpdateZipStatus = (payload) => ({
    type: UPDATE_ZIP_STATUS,
    payload
});

export const UpdateZipStatusSuccess = (payload) => ({
    type: UPDATE_ZIP_STATUS_SUCCESS,
    payload
});

export const UpdateZipStatusFailure = (payload) => ({
    type: UPDATE_ZIP_STATUS_FAILURE,
    payload
});

export const GetStates = (payload) => ({
    type: GET_STATES,
    payload
});

export const GetStatesSuccess = (payload) => ({
    type: GET_STATES_SUCCESS,
    payload
});

export const GetStatesFailure = (payload) => ({
    type: GET_STATES_FAILURE,
    payload
});

export const AddZip = (payload) => ({
    type: ADD_ZIP,
    payload
});

export const AddZipSuccess = (payload) => ({
    type: ADD_ZIP_SUCCESS,
    payload
});

export const AddZipFailure = (payload) => ({
    type: ADD_ZIP_FAILURE,
    payload
});

export const EditZip = (payload) => ({
    type: EDIT_ZIP,
    payload
});

export const EditZipSuccess = (payload) => ({
    type: EDIT_ZIP_SUCCESS,
    payload
});

export const EditZipFailure = (payload) => ({
    type: EDIT_ZIP_FAILURE,
    payload
});

export const ImportData = (payload) => ({
    type: IMPORT_ZIP_DATA,
    payload
});

export const ImportDataSuccess = (payload) => ({
    type: IMPORT_ZIP_DATA_SUCCESS,
    payload
});

export const ImportDataFailure = (payload) => ({
    type: IMPORT_ZIP_DATA_FAILURE,
    payload
});